<template>
  <section>
    <PageTitle>{{ $domUtils.decode(after_survey.title) }}</PageTitle>
    <PageContent>
      <Container>
        <ul class="answer-list">
          <li
            class="answer-list-item"
            v-for="(item, index) in items"
            :key="item.question_id"
          >
            <div class="answer">
              <h2 class="answer-title">
                <span class="answer-num">Q{{ index + 1 }}</span>
                <span class="space-r-3" v-html="$domUtils.decode($domUtils.nl2br(item.question_title))"></span>
                <span class="answer-edit-link" v-if="item.answered">
                  <router-link :to="`${showPath}#q-${index + 1}`">
                    回答を編集する
                  </router-link>
                </span>
              </h2>
              <div class="answer-body">
                <template v-if="item.answered">
                  <span class="space-r-4"></span>
                  <div class="answer-content">
                    <template v-if="item.isText">
                      <p v-html="$domUtils.clear(item.answer_text)" />
                    </template>
                    <template v-if="item.isTextarea">
                      <p
                        v-html="$domUtils.nl2br(item.answer_text_multi_line)"
                      />
                    </template>
                    <template v-if="item.isDate">
                      <p>{{ item.answer_date | formatDate }}</p>
                    </template>
                    <template v-if="item.isCheck">
                      <p
                        v-for="(option, index) in item.selectedOptions"
                        :key="option.option_id"
                        :class="{ 'space-t-3': index > 0 }"
                        v-html="$domUtils.decode($domUtils.nl2br(option.option_text))"
                      >
                      </p>
                    </template>
                    <template v-if="item.isCheckImage">
                      <ul class="imagebox-list is-4-cols">
                        <li
                          class="imagebox-list-item"
                          v-for="option in item.selectedOptions"
                          :key="option.option_id"
                        >
                          <figure class="imagebox is-rounded">
                            <div class="imagebox-content">
                              <img
                                :src="option.option_image"
                                :alt="$domUtils.decode(option.option_text)" />
                            </div>
                            <figcaption class="imagebox-footer">
                              <div class="imagebox-caption">
                                <p
                                  v-html="$domUtils.decode($domUtils.nl2br(option.option_text))"
                                >
                                </p>
                              </div>
                            </figcaption>
                          </figure>
                        </li>
                      </ul>
                    </template>
                    <template v-if="item.isImage">
                      <AnswerImages :items="item.answer_image" />
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="space-x-auto">
                    <router-link
                      :to="`${showPath}#q-${index + 1}`"
                      class="button waves-effect waves-light"
                    >
                      回答する
                    </router-link>
                  </div>
                </template>
              </div>
            </div>
          </li>
        </ul>
        <div class="text-center space-t-6">
          <router-link :to="$wcRouter.path({ name: 'after-survey.index' })">
            {{ $store.getters['app/getMenuName']('after-survey') }} 一覧へ
          </router-link>
        </div>
      </Container>
    </PageContent>
  </section>
</template>

<script>
import api from '@/api/after-survey'
import Question from '@/utils/Question'
import AnswerImages from '@/components/AnswerImages.vue'
import { formatDate } from '@/filters/format-date'
import { renderError, RESPONSE_UNAUTHORIZED } from '@/utils/error'

export default {
  components: {
    AnswerImages,
  },

  data() {
    return {
      after_survey: { title: '' },
      items: []
    }
  },

  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'after-survey-answer' }
    }
  },

  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
    afterSurveyId() {
      return this.$route.params.afterSurveyId * 1
    },
    showPath() {
      return this.$wcRouter.path({
        name: 'after-survey.show',
        params: { afterSurveyId: this.afterSurveyId }
      })
    },
  },

  filters: {
    formatDate,
  },

  methods: {
    /**
     * 施行後アンケート取得
     */
    async fetchAfterSurvey() {
      try {
        const afterSurveys = await api.afterSurveys(this.businessId)
        for (const afterSurvey of afterSurveys) {
          if (afterSurvey.after_survey_id === this.afterSurveyId) {
            this.after_survey.title = afterSurvey.after_survey_title
            return false
          }
        }
        if (this.after_survey.title === '') {
          // 編集可能日数を過ぎた施行後アンケートのURL直叩き防止
          renderError({ response : { status : RESPONSE_UNAUTHORIZED}})
        }
      } catch(err) {
        renderError(err)
      }
    },
    /**
     * 施行後アンケート質問の一覧を取得
     */
    async fetchAfterSurveyQuestions() {
      try {
        const response = await api.questions(this.businessId, this.afterSurveyId)

        this.items = response.map(res => new Question(res))
      } catch(err) {
        renderError(err)
      }
    },
  },

  created() {
    this.$withLoading(() => Promise.all([
      this.fetchAfterSurvey(),
      this.fetchAfterSurveyQuestions()
    ]))
  }
}
</script>
